<template>
<div class="login">
	<Toast />
	<ConfirmDialog/>
	<div class="bg-img"></div>
	<div class="login-container">
		<div class="logo-row">
			<img src="/images/login_logo.png" alt="경상남도버스경영수지분석">
		</div>
		<form class="container">
			<label for="username">아이디</label>
			<InputText id="username" placeholder="아이디" v-model="user.username" autofocus />

			<label for="password">비밀번호</label>
			<Password id="password" placeholder="암호" v-model="user.password" :feedback="false" toggleMask @keydown.enter="btnAct('LOGIN')" />

			<div class="field-checkbox mt-5">
				<Checkbox inputId="binary" v-model="checked" :binary="true" />
				<label for="binary">아이디저장</label>
			</div>

			<Button class="btn-login" @click="btnAct('LOGIN')" label="로그인"/>
		</form>

		<!--
		<div class="line"><span class="txt">or</span></div>
		<button class="btn-join" @click="btnAct('Signup')">회원가입</button>
		-->
		<div style="margin-top: 1rem; font-size:1.2em;">
			<font color="red">로그인 안내 및 문의사항 연락처</font><br/>
			1. 로그인 방법<br/>
			기존에 사용하던 아이디와 초기 비밀번호( kn1234** )를 입력하여 로그인 하신 후<br/>
			비밀번호를 변경하여 사용하십시오.<br/><br/>
			2. 시스템 문의 사항 연락처<br/>
			- 유지보수 업체 명: 가온소프트(주)<br/>
			- 담당자 명 : 김상언 사원<br/>
			- 담당자 전화: 070-4435-0077<br/>
			- 담당자 메일: kse@gaonsoft.com<br/>
			- 업체 대표번호: 055-231-7707<br/><br/>			
			3. 유지보수 및 시스템 적용을 위해 아래 시간대에는 사용을 자제해주세요<br/>
			- 시간: 12:00 ~ 13:00, 18:00 ~ 19:00<br/>
		</div>
	</div>
</div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
//import { useConfirm } from 'primevue/useconfirm';
import dayjs from "dayjs";
import { jsonp } from 'vue-jsonp';

export default {
	setup() {
		onMounted(() => {
			var obj = localStorage.getItem("isSaveIdFlag");
			checked.value = Boolean(obj);
			if(checked.value) {
				var _username = localStorage.getItem("username");
				if(_username != null && _username != undefined) {
					user.value.username = _username;
				}
			}

			// 접속자의 ip를 얻어온다
			getIp();
		})

		const isNoIp = ref(false);  
		const isDiffIp = ref(false); 
		const user = ref({username:null, password:null, accessIp:null});
		const router = useRouter();
		const toast = useToast();
		const store = useStore();
		const checked = ref(false);  // 아이디저장여부
		//const confirm = useConfirm();
		const btnAct = (_act) => {
			switch(_act)
			{
				case "LOGIN":
					localStorage.removeItem('token');
					
					store.dispatch('auth/login', user.value).then(
						(data) => {
							//alert('store.state.auth.user = ' + JSON.stringify(store.state.auth.user));
							//alert(JSON.stringify(data));
							//alert('ip = ' + store.state.auth.user.ip + ", custIp = "+ store.state.auth.user.custIp);

							// 로그인 성공 시, data에 사용자 정보가 담겨서 넘어오나 실패 시, false로 넘어온다
							if(data != false) {
								var accessIp = null;  // 접속한 사용자 ip
								var custSeq = null;  // 접속한 사용자가 속한 거래처Seq
								var custIp = null;  // 접속한 사용자가 속한 거래처의 ip

								if(store.state.auth.user != null) {
									accessIp = store.state.auth.user.accessIp;
									custSeq = store.state.auth.user.custSeq;
									custIp = store.state.auth.user.custIp;
								}

								if (localStorage.getItem("user") && localStorage.getItem("token")) {

									// 로그인 성공 시 ----------------------------
									if(checked.value) {
										localStorage.setItem("isSaveIdFlag", true);
										localStorage.setItem("username", user.value.username);
									}
									else {
										localStorage.removeItem('isSaveIdFlag');
										localStorage.removeItem('username');
									}

									var delayTime = 0;
									var now = dayjs();
									var _lastPwdDt = store.state.auth.user.lastPwdDt;

									if(_lastPwdDt != null) {
										var lastPwdDt = dayjs(_lastPwdDt, "YYYY-MM-DD HH:mm:ss"); 
										var diff = now.diff(lastPwdDt, "month");  // 현재일자 기준 경과 개월수
										if(Number(diff) >= 6) {
											toast.add({severity:'warn', summary: '경고', detail: "비밀번호 변경이 6개월을 초과하였습니다. 비밀번호는 6개월 단위로 변경하여 사용하시는 것이 안전합니다"});		
											delayTime = 2000;
										}
									}
									else {
										toast.add({severity:'warn', summary: '경고', detail: "마지막으로 변경된 암호변경일자가 없습니다. 비밀번호는 6개월 단위로 변경하여 사용하시는 것이 안전합니다"});		
										delayTime = 2000;
									}

									// 사용자가 속한 소속 거래처가 있는 경우
									if(custSeq != null && custSeq != "") {
										if(custIp == null ||  custIp == undefined) {
											//toast.add({severity:'warn', summary: '경고', detail: " 업체등록의 업체수정 화면에서 IP주소를 입력하세요!"});
											delayTime = 0;
											isNoIp.value = true;
										}
										else {
											// 현재 시점에서는 경고 메시지를 표시하지 않는다
											if(!custIp.includes(accessIp)) {
												delayTime = 0;
												isDiffIp.value = true;
											}
										}
									}

									// 메인 페이지로 이동한다
									//router.push({name: 'MainPage', params: {}}); 

									if(isDiffIp.value == true) {
										toast.add({severity:'error', summary: '접속 IP 오류', detail: '사용자의 IP주소가 업체에 등록된 IP주소와 다릅니다. 거래처IP: '+ custIp + ', 사용자IP: '+ accessIp, life: 3000});
										delayTime = 3000;
										setTimeout( () => router.push({name: 'MainPage', params: {}}), delayTime);
										
										/*	
										confirm.require({
											message:'사용자의 IP주소가 업체에 등록된 IP주소와 다릅니다. 거래처IP: '+ custIp + ', 사용자IP: '+ accessIp,
											header: '업체등록 화면에서 IP주소를 확인바랍니다',
											icon: 'pi pi-exclamation-triangle',
											accept: () => {
												setTimeout( () => router.push({name: 'MainPage', params: {}}), delayTime); // 3초 후에 메인화면으로 이동한다
											},
											reject: () => {
												//toast.add({severity:'error', summary:'취소', life: 3000});
											}
										})
										*/
									}
									else if(isNoIp.value == true) {
										toast.add({severity:'error', summary: '업체의 등록된 IP 없음', detail: "업체등록의 업체수정 화면에서 IP주소를 입력하세요!"});		
										delayTime = 3000;
										setTimeout( () => router.push({name: 'MainPage', params: {}}), delayTime); // 3초 후에 메인화면으로 이동한다

										/*
										confirm.require({
											message:'업체등록의 업체수정 화면에서 IP주소를 입력하세요! ',
											header: '업체에 등록된 IP 주소가 없습니다.',
											icon: 'pi pi-exclamation-triangle',
											accept: () => {
												setTimeout( () => router.push({name: 'MainPage', params: {}}), delayTime); // 3초 후에 메인화면으로 이동한다
											},
											reject: () => {
												//toast.add({severity:'error', summary:'취소', life: 3000});
											}
										})
										*/
									}
									else {
										setTimeout( () => router.push({name: 'MainPage', params: {}}), delayTime);
									}
								}
								else {
									user.value.password = "";
									toast.add({severity:'error', summary: '로그인 오류[0]', detail: "사용자의 사용여부가 승인되지 않았거나 계정이 잠겨있습니다. 관리자에게 문의하세요."});		
								}
							}
							else {
								user.value.password = "";
								toast.add({severity:'error', summary: '로그인 오류[1]', detail: "사용자 아이디/비밀번호가 일치하지 않습니다"});		
							}
						},
						error => {
							user.value.password = "";
							//toast.add({severity:'error', summary: '로그인 오류[2]', detail: error.message});	
							console.log(error.message);
							toast.add({severity:'error', summary: '로그인 오류[2]', detail: "아이디와 비밀번호를 다시 입력해주세요."});	
						}
					)
					break;
				case "Signup":
					router.push({name: 'SignupPage', params: {}});  // 회원가입 페이지로 이동한다
					break;
				default:
					break;
			}
		}

		/**
		 * 동기 지연
		 */
		const sleep = (ms) => {
			const wakeUpTime = Date.now() + ms;
			while (Date.now() < wakeUpTime) {
				console.log();
			}
		}

		/**
		 * 비동기 지연
		 */
		const asyncsleep = (ms) => {
			return new Promise((r) => setTimeout(r, ms));
		}

		/**
		 * 접속자의 ip를 리턴한다
		 */
		const getIp = async() => {
			await fetch('https://api.ipify.org?format=json')
			.then(x => x.json())
			.then(({ ip }) => {
				user.value.accessIp = ip;
				console.log('#1 accessIp = '+ ip);
			})
			.catch(error => {
				console.log('#1 getIp 오류 :', error);
			});

			if(user.value.accessIp === null) {
				let result1 = await jsonp('https://api64.ipify.org?format=jsonp');
				user.value.accessIp = result1.ip;
				console.log('#2 accessIp = '+ result1.ip);
			}

			if(user.value.accessIp === null) {
				let result2 = await jsonp('https://api.ipify.org?format=jsonp');
				user.value.accessIp = result2.ip;
				console.log('#3 accessIp = '+ result2.ip);
			}

			if(user.value.accessIp === null) {	
				await fetch('https://api.ip.pe.kr/json/')
				.then(x => x.json())
				.then(({ ip }) => {
					user.value.accessIp = ip;
					console.log('#4 accessIp = '+ ip);
				})
				.catch(error => {
					console.log('#4 getIp 오류 :', error);
				});
			}

			console.log('#최종 accessIp = '+ user.value.accessIp);
		}

		/*
		// 접속자 클라이언트의 공인(*외부) ip 주소를 얻어온다			
		// CORS 이슈가 있는 사이트에 적용하는 경우 문제를 해결하여 사용할 수 있는 jsonp 방식의 사용
		//json 방식은 사용자 컴퓨터에 따라 ip 주소를 얻어오지 못하는 경우가 발생하여 jsonp을 사용함
		// npm i jsonp
		var jsonp = require('jsonp');
		jsonp('https://api.ipify.org?format=jsonp', null, function (err, data) {
			if (err) {
				console.error(err.message);
				jsonp('https://api64.ipify.org?format=jsonp', null, function (err1, data1) {
					if (err) {
						console.error(err1.message);
					} else {
						user.value.accessIp = data1.ip;
						alert('#4 user.value.accessIp = '+ user.value.accessIp);
					}
				});
			} else {
				user.value.accessIp = data.ip;
				alert('#3 user.value.accessIp = '+ user.value.accessIp);
			}
		});
		
		// Node 방식 - 접속자 클라이언트의 공인(*외부) ip 주소를 얻어온다
		var http = require('http');
		http.get({'host': 'api.ipify.org', 'port': 80, 'path': '/'}, function(resp) {
			resp.on('data', function(ip) {
				//console.log("My public IP address is: " + ip);
				alert("#1 My public IP address is: " + ip);
			});
		});

		// fetch 방식 - 접속자 클라이언트의 공인(*외부) ip 주소를 얻어온다
		fetch('https://api.ipify.org?format=json')
		.then(x => x.json())
		.then(({ ip }) => {
			alert("# My public IP address is: " + ip);
			user.value.accessIp = ip;
		})
		.catch(error => {
			console.error('api.ipify.org 접속 오류 :', error);
			alert('api.ipify.org 접속 오류 :', error);
		});
		*/

		return { 
				user, checked, btnAct, sleep, asyncsleep, getIp,
		}
	}
}
</script>

<style lang="scss" scoped>
	*,
	*:before,
	*:after{
		padding: 0;
		margin: 0;
		box-sizing: border-box;
	}

	.bg-img {
		/* The image used */
		background-image: url("/images/bg_login.png");

		/* Control the height of the image */
		height: 100%;
		width: calc(100% - 846px);
		/* Center and scale the image nicely */
		background-position: center;
		background-repeat: no-repeat;
		background-position: right;
		background-size: cover;
		position: relative;
	}
	.login{
		display: flex;
		width: 100%;
		height: 100%;
	}
	.login-container{
		padding-left: 173px;
		width: 846px;
		background-color: white;
	}
	/* Add styles to the form container */
	.container {
		max-width: 500px;
	}

	.logo-row{
		padding: 25px 0 25px;
	}
	.background{
		width: 430px;
		height: 520px;
		position: absolute;
		transform: translate(-50%,-50%);
		left: 50%;
		top: 50%;
	}
	.background .shape{
		height: 200px;
		width: 200px;
		position: absolute;
		border-radius: 50%;
	}	

	.shape:first-child{
		background: linear-gradient(
			#1845ad,
			#23a2f6
		);
		left: -80px;
		top: -80px;
	}
	.shape:last-child{
		background: linear-gradient(
			to right,
			#ff512f,
			#f09819
		);
		right: -30px;
		bottom: -80px;
	}


	form *{
		font-family: 'NotoSansKR-Medium';
		//font-family: 'NotoSansKR';
		outline: none;
		border: none;
	}


	label{
		display: block;
		font-size: 17px;
		color: black;
	}
	input{
		display: block;
		height: 50px;
		width: 100%;
		background-color: rgba(255,255,255,0.07);
		border-radius: 3px;
		padding: 0 10px;
		margin-top: 8px;
		font-size: 14px;
		font-weight: 300;
	}
	::placeholder{
		color: #e5e5e5;
	}

	.p-inputtext{
		display: block;
		height: 64px;
		width: 100%;
		border-radius: 10px;
		padding: 0 10px;
		margin: 8px 0 36px;
		font-size: 16px;
		border: 1px solid #999999;
		
		&:last-child {
            margin-bottom: 0;
        }
		color: black;
	}
	::placeholder{
		color: #e5e5e5;
		font-family: 'NotoSansKR-Medium';
		//font-family: 'NotoSansKR';
	}

	.p-password {
		position: relative;
		display: inline-flex;
		width: 100%;
	}
	
	::v-deep(.p-password input) {
		position: relative;
		height: 64px;
		width: 100%;
		border-radius: 10px;
		padding: 0 10px;
		margin-top: 8px;
		font-size: 16px;
		border: 1px solid #999999;
		color: black;
		background-color: white;
		&::placeholder{
		color: #e5e5e5;
		font-family: 'NotoSansKR-Medium';
		//font-family: 'NotoSansKR';
		}
	}

	.checkbox-wrap{
		position: relative;
		padding-left: 30px;
		margin-top: 8px;
		label{
			line-height: 20px;
		}
		.checkmark {
			position: absolute;
			top: 3px;
			left: 0;
			height: 20px;
			width: 20px;
			background-color:white;
			border: 1px solid #003E92;
			border-radius: 4px;
			&::before {
				content: "";
				width: 20px;
				height: 20px;
				position: absolute;
				left: -2px;
				top: -2px;
				background-image: url("/images/ic_checked.png");
				background-position: center;
				background-repeat: no-repeat;
				display: none;
			}
		}
		
		input[type="checkbox"]{
			position: absolute;
			opacity: 0;
			cursor: pointer;
			height: 0;
			width: 0;
			&:checked ~ .checkmark {
				background-color: #003E92;
				&::before {
					display: inline-block;
				}
				}
				&:disabled ~ .checkmark{
					border: 1px solid #CCCCCC;
				}
				&:disabled{
					&:checked ~ .checkmark {
						background-color: #CCCCCC;
						border: 2px solid #CCCCCC;
						&::before {
							display: inline-block;
						}
					}
				}
		}
		
	}
	.p-button {
		margin-top: 50px;
		width: 100%;
		background-color: #ffffff;
		color: #080710;
		padding: 15px 0;
		font-size: 18px;
		font-weight: 600;
		border-radius: 5px;
		cursor: pointer;

		&:not(.p-button-icon-only) {
            display: flex;
            width: 100%;
			padding-left: 10px;
			padding-right: 10px;
        }
	}

	button{
		margin-top: 50px;
		width: 100%;
		background-color: #ffffff;
		padding: 15px 0;
		font-size: 18px;
		font-weight: 600;
		border-radius: 5px;
		cursor: pointer;
	}

	.btn-login{
		background-color: #003E92;
		color: white;
		border-radius: 10px;
		height: 64px;
		font-size: 20px;
		font-family: 'NotoSansKR-Bold';
		//font-family: 'NotoSansKR';
		width: 500px;
		margin-top: 30px;
		&:hover{
			background-color: #0F315F;
		}
	}
	.btn-join{
		background-color: white;
		border: 1px solid #999999;
		color: black;
		border-radius: 10px;
		height: 64px;
		font-size: 20px;
		font-family: 'NotoSansKR-Bold';
		//font-family: 'NotoSansKR';
		width: 500px;
		margin-top: 0;
		&:hover{
			background-color: #0F315F;
			color: white;
		}
	}
	.confirmation-content {
		display: flex;
		justify-content: center;
	}
	.social{
		margin-top: 30px;
		display: flex;
	}
	.social div{
		width: 150px;
		border-radius: 3px;
		padding: 5px 10px 10px 5px;
		background-color: rgba(255,255,255,0.27);
		color: #eaf0fb;
		text-align: center;
	}
	.social div:hover{
		background-color: rgba(255,255,255,0.47);
	}
	.social .fb{
		margin-left: 25px;
	}
	.social i{
		margin-right: 4px;
	}

	.line{
		border-top: 1px solid #EAEAEA;
		position: relative;
		margin: 45px 0 45px;
		width: 500px;
		.txt{
			background-color: white;
			font-size: 20px;
			color: #999999;
			width: 76px;
			text-align: center;
			position: absolute;
			top:-17px;
			left: 50%;
			transform: translateX(-50%);
		}
	}
	@media only screen and (max-width: 1540px){
		.login-container{
			padding: 0 120px 0 120px;
			width: 75vh;
		}
		.logo-row{
			padding: 40px 0 20px;
		}
		.bg-img{
			width: calc(100% - 75vh);
		}
	}
</style>